// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"vx_a bhi_b bhi_wb"};